import { getLayer, initializeSdk } from '@eventbrite/statsig';
import { AppProps, StatsigProps } from './types';

export const LISTING_PAGE_EXPERIMENTS_LAYER = 'listing_page_experiments';

const DISPLAY_ORGANIZER_RATING_EXPERIMENT = {
    defaultValue: false,
    layer: LISTING_PAGE_EXPERIMENTS_LAYER,
    param: 'display_organizer_rating',
};

export const getCustomUserIDfromExperimentCookie = () => {
    const cookieValue = document.cookie
        .split('; ')
        .find((row) => row.startsWith('allow_experiments_cookie='))
        ?.split('=')[1];
    return cookieValue;
};

export const checkGateFromServer = (
    gateName: string,
    statsigProps?: StatsigProps,
): Boolean =>
    statsigProps?.feature_gates?.hasOwnProperty(gateName)
        ? statsigProps.feature_gates[gateName]
        : false;

export const initializeStatsigSdk = async (app: AppProps) => {
    const isRepeatingEvent =
        app.event?.isSeriesParent && !!app.event?.childEvents;
    await initializeSdk({
        user: {
            userID: app.user.publicId,
            custom: {
                eventId: app.event?.id,
                organizerId: app.organizer?.id,
                ebDomain: app.env?.ebDomain,
                shouldShowCompactCheckout: app.event?.shouldShowCompactCheckout,
                isRepeatingEvent: isRepeatingEvent,
            },
        },
    });
};

export const isDisplayRatingExperientEnabled = () => {
    const value = getLayer(
        DISPLAY_ORGANIZER_RATING_EXPERIMENT.layer,
        DISPLAY_ORGANIZER_RATING_EXPERIMENT.param,
        DISPLAY_ORGANIZER_RATING_EXPERIMENT.defaultValue,
    );

    return value === true || value === 'true';
};
